// project
import * as C from "@/components.tags/tags-home";

export const TagsHome = {
	path: "/tags",
	name: "view-tags",
	component: C.TagsHome,
	meta: {
		title: "Tags"
	},
};